var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "header",
      { staticClass: "header--compact", attrs: { id: "header" } },
      [
        _c(
          "router-link",
          { attrs: { id: "header__logo", to: { name: "dashboard" } } },
          [
            _c("img", {
              attrs: {
                src: "/images/logo/logo-abstract.png",
                alt: "Logo",
                width: "30",
              },
            }),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("main", { staticClass: "container", attrs: { id: "content" } }, [
      _c(
        "div",
        { attrs: { id: "content__form" } },
        [
          _c(
            "header",
            { attrs: { id: "content__header" } },
            [_vm._t("header")],
            2
          ),
          _vm._v(" "),
          _c("nav", { attrs: { id: "content__nav" } }, [_vm._t("nav")], 2),
          _vm._v(" "),
          _vm._t("default"),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }